import Modal, { ModalProps } from 'antd/lib/modal/Modal';
import React from 'react';
import { PdfViewer } from '~components/atoms/Viewers/PdfViewer/PdfViewer';
import { PdfViewerCopy } from '~components/atoms/Viewers/PdfViewer/PdfViewerCopy';

export interface PdfCompareProps extends Partial<ModalProps> {
  pdf1?: string;
  pdf2?: string;
  pdfName1?: string;
  pdfName2?: string;
  onDone?: () => void;
}

export const PdfCompareModal: React.FC<PdfCompareProps> = ({
  pdf1,
  pdf2,
  pdfName1,
  pdfName2,
  ...modalProps
}) => {
  return (
    <Modal
      {...modalProps}
      footer={false}
      wrapClassName={`pdf`}
      bodyStyle={{ height: '100%', paddingTop: 20 }}>
      <div style={{ display: 'flex', flexDirection: 'row', height: '98vh' }}>
        <div
          style={{
            width: '50%',
            maxWidth: '50%',
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
          }}>
          <div style={{ marginBottom: '10px' }}>{pdfName1}</div>
          <PdfViewer fileUrl={pdf1 || ''} canBeClosed={false} />
        </div>
        <div
          style={{
            width: '50%',
            maxWidth: '50%',
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
          }}>
          <div style={{ marginBottom: '10px' }}>{pdfName2}</div>
          <PdfViewerCopy fileUrl={pdf2 || ''} canBeClosed={false} />
        </div>
      </div>
    </Modal>
  );
};
